import React from 'react'
import { useTranslation } from 'react-i18next'
import { View, Text } from 'react-native'
import { PulseOpsFormat, TaskDetail, RequestListPolicyInfo } from '@pulseops/common'
import { GridView } from './gridview'
import { ContainerView, styles } from './styles'

export const PolicyInfoView = (props: { detail?: RequestListPolicyInfo }) => {
  const { detail } = props
  const { t: ca, i18n } = useTranslation('Cashless')

  const fields = React.useMemo(() => {
    // const rider = riderList.find((e) => e.code === detail.productCode)
    // const productName = [detail.productCode, detail.productType].filter((s): s is string => !!s).join(' - ')
    return [
      {
        label: ca('installmentPremium'),
        value: PulseOpsFormat.currency(detail?.installmentPremium ?? 0) + ' VND'
      },
      {
        label: ca('product'),
        // value: productName
        value: detail?.product
      },
      {
        label: '',
        value: ''
      },
      {
        label: ca('lastestBilling'),
        value: detail?.lastestBilling
      },
      {
        label: ca('lastAPLDate'),
        value: detail?.lastAPLDate
      },
      {
        label: ca('latestAppliedPremium'),
        value: detail?.latestAppliedPremium
      },
      {
        label: ca('excessPremium'),
        value: PulseOpsFormat.currency(detail?.excessPremium ?? 0) + ' VND'
      },
      {
        label: ca('policyLoanPrincipal'),
        value: PulseOpsFormat.currency(detail?.policyLoanPrincipal ?? 0) + ' VND'
      },
      {
        label: ca('aplPrinciple'),
        value: PulseOpsFormat.currency(detail?.aplPrinciple ?? 0) + ' VND'
      },
      {
        label: ca('discountPremium'),
        value: PulseOpsFormat.currency(detail?.discountPremium ?? 0) + ' VND'
      },
      {
        label: ca('policyLoanInterest'),
        value: PulseOpsFormat.currency(detail?.policyLoanInterest ?? 0) + ' VND'
      },
      {
        label: ca('aplInterest'),
        value: PulseOpsFormat.currency(detail?.aplInterest ?? 0) + ' VND'
      }
    ]
  }, [i18n])

  return (
    <View>
      <View style={{ marginTop: 15 }}>
        <Text style={styles.sessonText}>{ca('policyInfo')}</Text>
      </View>
      <ContainerView>
        <GridView data={fields} />
      </ContainerView>
    </View>
  )
}
